/**
 * The two durations decision 16 wants, so the seven-day reset hold can be
 * revisited with data rather than opinion (#1692).
 *
 * RECORDED WHERE THE MEMBER ACTS, not where a push is tapped. An approval is
 * an approval whether it followed a notification, a poll, or the member opening
 * the app on their own; timing from the tap would measure only the taps and
 * miss every approval that never had one — which is exactly the population the
 * hold length has to be safe for.
 *
 * ELAPSED SECONDS AND NOTHING ELSE. No device name, no note, no member id, no
 * timestamp that could be joined against another event. There is nothing here
 * to mask, which is what keeps this inside decision 10 rather than needing the
 * masking that decision applies to session replay.
 */
import { trackEvent } from '@/utils/mixpanel';

/**
 * @param {string} event
 * @param {string | null | undefined} since ISO 8601, from the status body
 * @param {typeof trackEvent} [track]
 */
export function trackElapsedSince(event, since, track = trackEvent) {
  const started = since ? Date.parse(since) : NaN;
  // No timestamp is not zero seconds: a member whose status did not carry one
  // would otherwise pull every average towards nothing.
  if (!Number.isFinite(started)) return;

  const seconds = Math.round((Date.now() - started) / 1000);
  // A device clock that moved backwards, or a timestamp from the future, is
  // not a measurement — it is noise dragging an average nobody can explain.
  if (seconds < 0) return;

  track(event, { seconds });
}
